var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 840,
    viewBox: "0 0 1000 840",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6334 0 0 2.6334 517.048 452.8562)",
    id: 897857
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.7462 8.3033)",
    id: "CART_No_X"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-198.7138, -327.7633)",
    d: "M 269.95 257.1 c -13.02 -5.32 -18.24 -2.14 -30.41 -3.68 c -1.79 -0.23 -11.38 -11.71 -13 -13.48 c -11.01 -12.28 -16.96 -22.68 -27.33 -34.9 c -2.95 -3.55 -6.08 -6.96 -9.26 -9.48 c -5.32 -4.25 -9.72 -3.06 -12.62 2.74 c -1.01 1.97 -1.7 4.4 -2.41 6.75 c -8.77 26.53 -18.98 52.86 -30.22 79.33 c -1.75 3.85 -2.78 9.02 -2.68 13.69 c 0.31 16.32 1.14 32.69 1.96 49.04 c 0.42 8.6 0.16 16.89 -1.7 25.15 c -5.64 23.42 -11.37 46.94 -17.63 70.4 c -2.2 7.82 0.82 13.86 7.59 16.03 c 7.45 2.38 14.09 -1.09 16.24 -8.44 c 6.88 -25.07 13.01 -50.24 18.83 -75.36 c 2.11 -9.91 2.68 -19.93 1.3 -30.48 c -1.16 -8.89 -2.03 -17.78 -3.01 -26.68 c -0.17 -1.57 -0.22 -3.14 -0.32 -4.71 c 0.29 -0.2 0.58 -0.39 0.87 -0.59 c 0.26 0.56 0.49 1.15 0.8 1.66 c 11.75 18.82 24.12 37.67 37 56.65 c 0.84 1.21 1.42 2.86 1.62 4.28 c 1.78 13.02 3.37 26.03 5.11 39.04 c 1.64 12.4 3.24 24.81 5.2 37.22 c 0.92 5.83 3.84 8.77 8.84 10.35 c 10.18 3.2 16.67 -2.57 15.25 -13.56 c -3 -22.57 -5.94 -45.15 -9.28 -67.75 c -1.5 -9.9 -3.51 -20.02 -9.79 -28.81 c -12.58 -18.1 -24.88 -35.93 -36.67 -53.67 c -1.73 -2.66 -1.82 -4.37 -0.81 -6.79 c 3.6 -8.95 6.87 -18.06 10.06 -27.12 c 2.77 -8.3 5.42 -16.61 8.02 -25.24 c 1.33 1.27 2.32 2.19 3.3 3.16 c 7.61 7.41 15.43 14.74 23.32 22.34 c 4.43 4.2 8.9 6.23 13.41 6.09 c 13.05 -0.4 28.05 -1.65 29.26 -2.43 c 2.66 -1.74 4.75 -5.84 -0.8 -10.74 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.464 -147.7696)",
    id: "CART_No_X"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-205.996, -171.6904)",
    d: "M 206.02 194.61 c -13.07 -0.11 -23.03 -10.08 -22.97 -22.99 c 0.06 -12.56 10.33 -22.82 22.86 -22.85 c 12.63 -0.03 23.21 10.59 23.03 23.14 c -0.18 12.72 -10.36 22.81 -22.92 22.7 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.23 36.52)",
    id: "CART_No_X"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-388.69, -355.98)",
    d: "M 491.18 423.18 v -153.08 h -176.28 c -0.82 -4.24 -2.65 -9.29 -6.58 -13.7 c -5.64 -6.32 -13.85 -9.52 -24.4 -9.52 c -4.59 0 -8.31 3.72 -8.31 8.31 s 3.72 8.31 8.31 8.31 c 5.56 0 9.58 1.31 11.93 3.89 c 2.11 2.31 2.78 5.43 2.97 7.6 v 3.35 s 0 0.05 0 0.07 v 142.29 c -9.21 2.9 -15.89 11.5 -15.89 21.67 c 0 12.54 10.17 22.71 22.71 22.71 s 22.61 -10.07 22.71 -22.53 h 128 c 0.1 12.46 10.23 22.53 22.71 22.53 s 22.71 -10.17 22.71 -22.71 c 0 -8.09 -4.23 -15.18 -10.59 -19.2 Z m -16.63 -3.06 c -4.28 0.86 -8.12 2.93 -11.16 5.83 h -142.09 c -1.72 -1.64 -3.69 -3.02 -5.86 -4.05 v -60.58 h 159.12 v 58.81 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.71c2d8e04959a3482105c7df2d5d5ed0.svg";
export { ForwardRef as ReactComponent };